import { DollarSign } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Property, PricingRule } from '@/types/revenue-manager';
import { useCurrencyFormat } from '@/hooks/use-currency-format';

interface MetricsRowProps {
  property: Property;
  rules: PricingRule[];
  onBasePriceChange: (price: number) => void;
}

export function MetricsRow({ property, rules, onBasePriceChange }: MetricsRowProps) {
  const { format, symbol } = useCurrencyFormat();
  const activeRules = rules.filter((r) => r.isActive);
  const avgAdjustment =
    activeRules.length > 0
      ? activeRules.reduce((sum, r) => sum + r.adjustmentValue, 0) / activeRules.length
      : 0;
  const revenueImpact = (property.basePrice * avgAdjustment) / 100;

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {/* Base Price Input */}
      {/* <div className="metric-card">
        <div className="flex items-center justify-between">
          <p className="text-sm font-medium">Base Price</p>
          <span className="text-xs text-muted-foreground">Per Night</span>
        </div>
        <div className="mt-3 flex items-center gap-2">
          <span className="text-lg font-semibold text-muted-foreground">{symbol}</span>
          <Input
            type="number"
            value={property.basePrice}
            onChange={(e) => onBasePriceChange(Number(e.target.value))}
            className="h-10 border-0 bg-transparent p-0 text-2xl font-bold focus-visible:ring-0"
          />
        </div>
      </div> */}

      {/* Active Rules */}
      <div className="metric-card">
        <p className="text-sm font-medium">Active Rules</p>
        <p className="mt-3 text-2xl font-bold">{activeRules.length}</p>
        <p className="text-sm text-muted-foreground">{rules.length} total rules</p>
      </div>

      {/* Avg Adjustment */}
      <div className="metric-card">
        <p className="text-sm font-medium">Avg Adjustment</p>
        <p className="mt-3 text-2xl font-bold">{avgAdjustment.toFixed(0)}%</p>
        <p className="text-sm text-muted-foreground">From active rules</p>
      </div>

      {/* Total Revenue Impact */}
      <div className="metric-card">
        <p className="text-sm font-medium">Total Revenue Impact</p>
        <p className="mt-3 text-2xl font-bold text-status-active">
          {revenueImpact >= 0 ? '+' : ''}{format(revenueImpact)}
        </p>
        <p className="text-sm text-muted-foreground">Calculated impact</p>
      </div>
    </div>
  );
}
